export default "__VITE_ASSET__CaB5DOeg__"